import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import * as Yup from 'yup';
import { Form, Formik, Field } from 'formik';
import * as Icon from '@mui/icons-material/';
import { createBrowserHistory } from 'history';
import { BoxButtons, Button } from '../../../Styles/ScreenStyle';
import { HeaderComponent } from '../../../../shared/components/HeaderComponent';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import UnidadeMedidaController from '../../../../controllers/UnidadeMedidaController';
import { toast } from 'react-toastify';
import { useLocation} from 'react-router-dom';

export default function UnidadeMedidaCadastrar() {
  const { userId } = useSelector((state: any) => state.Authentication);

  const history = createBrowserHistory();
  const [single, setSingle] = useState<any>(null);
  const { id } = useParams();
  const UnidadeMedidaId = id ? parseInt(id, 10) : null;
  const location = useLocation();
  const duploClick = location.state?.duploClick || false;

  useEffect(() => {
    if (UnidadeMedidaId !== null && UnidadeMedidaId !== undefined) {
      getSingle(UnidadeMedidaId);
    }
  }, [UnidadeMedidaId]);

  const getSingle = async (UnidadeMedidaId: number) => {
    const Response = await UnidadeMedidaController.ListarUnico(UnidadeMedidaId);

    setSingle(Response.Data);
  };

  const handleSubmit = async (
    values: any,
    { setSubmitting, resetForm }: any
  ) => {
    if (UnidadeMedidaId === null) {
      const response = await UnidadeMedidaController.Adicionar(values);

      if (response.StatusCode === 204) {
        toast('Unidade de medida incluido com sucesso!', {
          type: 'success',
        })
        resetForm();
      } else {
        toast('Erro ao incluir a unidade de medida!', {
          type: 'success',
        })
        resetForm();
      }
    } else {
      EditarContato(values, { setSubmitting, resetForm });
    }

    setSubmitting(false);
  };

  const EditarContato = async (
    values: any,
    { setSubmitting }: any
  ) => {
    const request = {
      UnidadeMedidaId: UnidadeMedidaId,
      ...values,
    };

    const response = await UnidadeMedidaController.Atualizar(request);

    if (response.StatusCode === 204) {
      toast('Unidade de medida atualizado com sucesso!', {
        type: 'success',
      })
    } else {
      toast('Erro ao atualizar a unidade de medida!', {
        type: 'error',
      })
    }
    setSubmitting(false);
  };

  const initialValues = {
    UsuId: userId,
    Descricao: single?.unm_descricao || '',
  };

  const validationSchema = Yup.object().shape({
    Descricao: Yup.string()
      .required('Campo Obrigatorio!')
      .min(4, 'O Campo deve ter no minimo 4 caracteres'),
  });

  return (
    <Box
      sx={{
        '& .MuiTextField-root': { m: 1, width: '35ch' },
      }}
    >
      <HeaderComponent text={'CADASTRO DE UNIDADE DE MEDIDAS'} className={'mb-5'} />

      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ errors }) => (
          <Form>
            <BoxButtons>
              <Button
                variant='contained'
                onClick={() => history.back()}
                color='warning'
                startIcon={<Icon.ArrowBack />}
              >
                Voltar
              </Button>
              <Button
                type={'submit'}
                variant='contained'
                color='success'
                startIcon={<Icon.Save />}
                disabled={duploClick}
              >
                Salvar
              </Button>
            </BoxButtons>
            <fieldset disabled={duploClick}>
            <Field
              name='Descricao'
              required
              as={TextField}
              label='Descricao'
              placeholder=''
              type='text'
              error={Boolean(errors?.Descricao)}
              helperText={errors?.Descricao}
            />
            </fieldset>
          </Form>
        )}
      </Formik>
    </Box>
  );
}
